import "./new-payment.scss";

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormPayment from "../form-payment/form-payment";
import { useNewPayment } from "./new-payment.hook";

export interface NewPaymentProps {
  isBulk?: boolean;
  balance?: number;
}

export function NewPayment({ isBulk, balance }: NewPaymentProps) {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewPayment(isBulk);

  return (
    <div id="NewPayment" className="payment">
      <HeaderContent
        title={<h1>New Payment</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 gap-2 mb-4">
            <FormPayment isBulk={isBulk} balance={balance} />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewPayment;
